// extracted by mini-css-extract-plugin
module.exports = {"input":"Toggle-input_dea6e875","slider":"Toggle-slider_d5441039","indicator":"Toggle-indicator_25f51940"};